export default __webpack_public_path__ + "static/media/237.010f5588.jpg";